<template>
  <el-row class="wrapper">
    <el-col :span="2">
      <div style="margin-bottom: 5%">圖台監控</div>
      <div>最後更新</div>
      <div>{{ vx_lastUpdate }}</div>
    </el-col>
    <el-col :span="2">
      <span>總車輛:</span>
      <span class="blockinline red_textcolor">
        {{ vx_carStatusCount.total }}
      </span>
    </el-col>
    <el-col :span="16" class="info">
      <div>
        <a>
          <img :src="require('@/assets/images/driver-status/taxi.png')" />
          空車
        </a>
        <h5 class="blockinline fontSize20 red_textcolor">
          {{ vx_carStatusCount.vacant }}
        </h5>
      </div>
      <div>
        <a>
          <img
            :src="require('@/assets/images/driver-status/take_passenger.png')"
          />
          載客中
        </a>
        <h5 class="blockinline fontSize20 red_textcolor">
          {{ vx_carStatusCount.hired }}
        </h5>
      </div>
      <div>
        <a>
          <img :src="require('@/assets/images/driver-status/hailing.png')" />
          派遣中
        </a>
        <h5 class="blockinline fontSize20 red_textcolor">
          {{ vx_carStatusCount.dispatched }}
        </h5>
      </div>
      <div>
        <a>
          <img :src="require('@/assets/images/driver-status/shift.png')" />
          排班車
        </a>
        <h5 class="blockinline fontSize20 red_textcolor">
          {{ vx_carStatusCount.shift }}
        </h5>
      </div>
      <div>
        <a>
          <i class="fa fa-ban fa-1x"></i>
          停權
        </a>
        <h5 class="blockinline fontSize20 red_textcolor">
          {{ vx_carStatusCount.suspension }}
        </h5>
      </div>
      <div>
        <a>
          <img :src="require('@/assets/images/driver-status/rest.png')" />
          休息中
        </a>
        <h5 class="blockinline fontSize20 red_textcolor">
          {{ vx_carStatusCount.rest }}
        </h5>
      </div>
      <div>
        <a>
          <img :src="require('@/assets/images/driver-status/interrupt.png')" />
          失聯
        </a>
        <h5 class="blockinline fontSize20 red_textcolor">
          {{ vx_carStatusCount.disappear }}
        </h5>
      </div>
      <div>
        <a>
          <img :src="require('@/assets/images/driver-status/logout.png')" />
          登出
        </a>
        <h5 class="blockinline fontSize20 red_textcolor">
          {{ vx_carStatusCount.logout }}
        </h5>
      </div>
    </el-col>
    <el-col :span="4">
      <button
        type="button"
        :class="{ 'btn-danger': !vx_sortBy, 'btn-dark': vx_sortBy }"
        @click="onFilter(false)"
        class="btn"
      >
        全部車輛
      </button>
      <button
        type="button"
        :class="{ 'btn-danger': vx_sortBy, 'btn-dark': !vx_sortBy }"
        @click="onFilter(true)"
        class="btn"
      >
        上線車輛
      </button>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  methods: {
    ...mapMutations('driverMonitor', {
      vx_setSortBy: 'setSortBy',
    }),
    onFilter(isSortBy) {
      this.vx_setSortBy(isSortBy)
      this.$emit('setDriverMarkers')
    },
  },
  computed: {
    ...mapState('driverMonitor', {
      vx_carStatusCount: 'carStatusCount',
      vx_lastUpdate: 'lastUpdate',
      vx_sortBy: 'sortBy',
    }),
  },
}
</script>

<style scoped>
.wrapper {
  font-size: 2rem;
  color: black;
  padding: 0.5%;
  background: #fff;
  border: 1px solid #e6e9ed;
}

.info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  div {
    color: black;
    margin-left: 1%;
    margin-right: 1%;
  }
  a {
    color: black;
  }
}

.btn {
  font-size: 2rem;
}

@media (max-width: 1000px) {
  .wrapper,
  .btn {
    font-size: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/driver-monitor-components-v2/Header.vue